"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroImageBlock = exports.HeroSlideStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        position: relative;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      height: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  align-self: stretch;\n  min-height: 100%;\n  width: 50%;\n\n  ", "\n\n  ", " {\n    height: 211px;\n    min-height: auto;\n    width: 100%;\n\n    ", "\n  }\n\n  img {\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: ", ";\n  position: relative;\n  text-align: center;\n  justify-content: stretch;\n\n  ", " {\n    flex-direction: column-reverse;\n    min-height: auto;\n    padding: 0;\n    justify-content: flex-end;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HeroSlideStyled = (0, _uiKit.styled)("div")(_templateObject(), function (_ref) {
  var layout = _ref.layout;
  return layout === 'img_right' ? 'row' : 'row-reverse';
}, _uiKit.GridBreakpointsMediaDown.sm);
exports.HeroSlideStyled = HeroSlideStyled;
var HeroImageBlock = (0, _uiKit.styled)("div")(_templateObject2(), function (_ref2) {
  var isCovered = _ref2.isCovered;
  return isCovered && (0, _uiKit.css)(_templateObject3());
}, _uiKit.GridBreakpointsMediaDown.sm, function (_ref3) {
  var isCovered = _ref3.isCovered;
  return isCovered && (0, _uiKit.css)(_templateObject4());
});
exports.HeroImageBlock = HeroImageBlock;